import React from 'react';

import GenericIconProps from './_icon.type';

export default function ArrowLeftFirstIcon({ className = 'fill-gray-350' }: GenericIconProps) {
  return (
    <svg
      className={className || ''}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_14319_16473" maskUnits="userSpaceOnUse" x="4" y="4" width="24" height="24">
        <rect x="4" y="4" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_14319_16473)">
        <path d="M20.3 21.3L15.7 16.7C15.6 16.6 15.5292 16.4917 15.4875 16.375C15.4458 16.2583 15.425 16.1333 15.425 16C15.425 15.8667 15.4458 15.7417 15.4875 15.625C15.5292 15.5083 15.6 15.4 15.7 15.3L20.3 10.7C20.4833 10.5167 20.7167 10.425 21 10.425C21.2833 10.425 21.5167 10.5167 21.7 10.7C21.8833 10.8833 21.975 11.1167 21.975 11.4C21.975 11.6833 21.8833 11.9167 21.7 12.1L17.8 16L21.7 19.9C21.8833 20.0833 21.975 20.3167 21.975 20.6C21.975 20.8833 21.8833 21.1167 21.7 21.3C21.5167 21.4833 21.2833 21.575 21 21.575C20.7167 21.575 20.4833 21.4833 20.3 21.3ZM11 22C10.7167 22 10.4792 21.9042 10.2875 21.7125C10.0958 21.5208 10 21.2833 10 21V11C10 10.7167 10.0958 10.4792 10.2875 10.2875C10.4792 10.0958 10.7167 10 11 10C11.2833 10 11.5208 10.0958 11.7125 10.2875C11.9042 10.4792 12 10.7167 12 11V21C12 21.2833 11.9042 21.5208 11.7125 21.7125C11.5208 21.9042 11.2833 22 11 22Z" />
      </g>
    </svg>
  );
}
